import React from 'react';
import {useQuery} from "@apollo/client";
import {CURRENT_TRAINER_WITH_REGION_QUERY} from '../../queries/queries';
import Error from '../error';
import Loading from '../loading';
import Trainer from './trainer'

const TrainerContainer = ({ }) => {
  const {loading, error, data} = useQuery(CURRENT_TRAINER_WITH_REGION_QUERY, {
    fetchPolicy: 'no-cache',
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  return (<Trainer trainers={data.currentTrainersWithRegion} />);
};

export default TrainerContainer;
